/**
 * What new members get in the Abby welcome (spec 2026-10-23 §5 Tab 2):
 * "Abby reads the text" or "Play a video". Native radio buttons in a
 * fieldset, so the keyboard and screen readers work without extra code. The
 * choice is part of the draft: Publish sends it.
 */
import type { WelcomeMode } from '../lib/welcome-state';

interface Props {
  value: WelcomeMode;
  disabled: boolean;
  onChange: (mode: WelcomeMode) => void;
  /** Start of the element ids. */
  idPrefix: string;
}

const OPTIONS: { mode: WelcomeMode; label: string; help: string }[] = [
  {
    mode: 'voice',
    label: 'Abby reads the text',
    help:
      "Abby's voice reads the text below, one paragraph at a time. The text appears as she reads it. " +
      'Your own text and voice play on app 1.0.5 and later. Older app versions show the built-in welcome.',
  },
  {
    mode: 'video',
    label: 'Play a video',
    help: 'A video with sound plays in the Abby tab. It plays on app 1.0.5 and later. Older app versions show the built-in text.',
  },
];

export function WelcomeModeField({ value, disabled, onChange, idPrefix }: Props) {
  return (
    <fieldset className="space-y-2 rounded-lg border bg-card p-5" disabled={disabled}>
      <legend className="px-1 text-base font-semibold">What new members get</legend>
      {OPTIONS.map((o) => {
        const id = `${idPrefix}-mode-${o.mode}`;
        return (
          <div key={o.mode} className="flex items-start gap-3">
            <input
              id={id}
              type="radio"
              name={`${idPrefix}-mode`}
              value={o.mode}
              checked={value === o.mode}
              onChange={() => onChange(o.mode)}
              aria-describedby={`${id}-help`}
              className="mt-1 h-4 w-4 accent-primary"
            />
            <div>
              <label htmlFor={id} className="text-sm font-medium">
                {o.label}
              </label>
              <p id={`${id}-help`} className="text-xs text-muted-foreground">
                {o.help}
              </p>
            </div>
          </div>
        );
      })}
    </fieldset>
  );
}
